/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React, {useState, useEffect} from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import Pagination from "./Pagination";
import {WealthyEnv} from "helpers";
import {colors} from "nxtconstants";

const propTypes = {
  countPerPage: PropTypes.number,
  currentPage: PropTypes.number,
  pageState: PropTypes.object
};

const defaultProps = {
  accordianList: {}
};

const PaginationContainer = ({
  pageState,
  currentPage,
  countPerPage
}) => {
  const [currentPath, setCurrentPath] = useState("");
  const [paramCount, setParamCount] = useState(0);

  useEffect(() => {
    let basePath = window.location.pathname;
    const params = new URLSearchParams(window.location.search);
    let currentParamCount = 0;
    for (const [key, value] of params.entries()) {
      if (key !== "page") {
        if (currentParamCount >= 1) {
          basePath = `${basePath}&${key}=${value}`;
        } else {
          basePath = `${basePath}?${key}=${value}`;
        }
        currentParamCount += 1;
      }
    }
    setCurrentPath(basePath);
    setParamCount(currentParamCount);
  }, []);

  const arrowRight = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-advisors-carousel-right-arrow.svg`;
  const arrowLeft = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-advisors-carousel-left-arrow.svg`;
  const totalPages = Math.ceil(pageState?.totalCount / countPerPage);

  const loadPagination = () => (
  <>
    <PaginationItem>
      <PaginationLink
        className={`${parseInt(currentPage) <= 1 ? "isDisabled" : ""}`}
        href={`${currentPath}${paramCount > 0 ? "&" : "?"}page=${parseInt(currentPage) - 1}`}
      >
        <Icon src={arrowLeft} alt="Previous page" />
      </PaginationLink>
    </PaginationItem>
    {
      Array.from({length: totalPages}, (_, index) => (
        <PaginationItem key={index}>
          <PaginationLink
            className={`${index + 1 === parseInt(currentPage) ? "current" : ""}`}
            href={`${currentPath}${paramCount > 0 ? "&" : "?"}page=${index + 1}`}
          >
            {index + 1}
          </PaginationLink>
        </PaginationItem>
      ))
    }
    <PaginationItem>
      <PaginationLink
        className={`${parseInt(currentPage) >= totalPages ? "isDisabled" : ""}`}
        href={`${currentPath}${paramCount > 0 ? "&" : "?"}page=${parseInt(currentPage) + 1}`}
      >
        <Icon src={arrowRight} alt="Next page" />
      </PaginationLink>
    </PaginationItem>
  </>
  );
  return (
    <Pagination
      currentPage={currentPage}
      currentPath={currentPath}
      loadPagination={loadPagination}
      paramCount={paramCount}
      totalPages={totalPages}
    />
  );
};

const PaginationItem = styled.li`
  margin: 0 0.75rem;
`;

const PaginationLink = styled.a`
  padding: 0 0.75rem;
  color: ${colors.dullGray};
  font-size: 1.8rem;
  border-bottom: 2px solid transparent;
  transition: all 0.15s ease-in-out;

  &.current, &:hover {
    color: ${colors.textBlack};
    border-color: ${colors.primary};
  }

  &.isDisabled {
    color: currentColor;
    cursor: not-allowed;
    text-decoration: none;
    pointer-events: none;
  }
`;

const Icon = styled.img`
  height: 14px;
`;

PaginationContainer.propTypes = propTypes;
PaginationContainer.defaultProps = defaultProps;

export default PaginationContainer;
